<app-filter class="filterBox" [name]="name" (selectedHeader)="getPromoData($event)" (selectedFilter)="handleSelectedFilter($event)"></app-filter>
